import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    Tabs,
    Tab,
    Grid,
    Card,
    Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import CircularLoader from "../../../components/loaders/circularLoader";
import DataTableWithCheckbox from "../../../components/dataTableWithSearch/DataTableWithCheckBox";
import { qrDialogPaperSx, QrModalHeader } from "../../qrCode/components/qrUi";
import CustomButton from "../../../components/buttons/customButton";
import DownloadIcon from "@mui/icons-material/Download";
import { useSelector, useDispatch } from "react-redux";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import DeleteIcon from "@mui/icons-material/Delete";
import { getChatBotClickHistoryThunk, deleteChatBotThunk, getChatBotThunk } from "../chatBotThunk";
import SnackbarMessage from "../../../components/snackBar/snackBar";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function ChatBotClickHistoryModal({ show, handleClose, rowData, }) {
    const dispatch = useDispatch();
    const { getBotClickHistory, status1, status } = useSelector((state) => state.chatBot);

    const [tabValue, setTabValue] = useState(0);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // Reset tab when modal opens
    useEffect(() => {
        if (show) {
            setTabValue(0);
        }
    }, [show]);

    // Fetch click history when modal opens
    useEffect(() => {
        if (show && rowData?.id) {
            handleClickHistory(rowData.id);
        }
    }, [show, rowData, dispatch]);

    const handleClickHistory = async (id) => {
        try {
            const result = await dispatch(getChatBotClickHistoryThunk({ chat_bot_id: id }));

            if (result.meta.requestStatus !== "fulfilled") {
                setSnackbar({
                    open: true,
                    message: result.payload || "Failed to fetch chat bot history.",
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };

    const { chat_bot_name } = rowData || {};

    // Columns for DataTable
    const columns = [
        { header: "S.No", accessorKey: "sno" },
        { header: "Name", accessorKey: "name" },
        { header: "Mobile", accessorKey: "mobile" },
        ...(Array.isArray(getBotClickHistory?.headerData)
            ? getBotClickHistory.headerData
                .filter((item) => item.bot_option !== "") // Skip empty options
                .map((item) => ({
                    accessorKey: item.bot_id?.toString(),
                    header: item.bot_option?.toString(),
                }))
            : []),
    ];

    const tableData = Array.isArray(getBotClickHistory?.userCounts)
        ? getBotClickHistory.userCounts.map((item, index) => {
            const flattened = {
                sno: index + 1,
                name: item.name || "-",
                mobile: item.mobile || "-",
            };

            if (Array.isArray(item.count)) {
                item.count.forEach((c) => {
                    flattened[c.bot_id] = c.count;
                });
            }

            return flattened;
        })
        : [];



    const handleDeleteTemplate = async (id) => {
        try {
            const response = await dispatch(deleteChatBotThunk({ credentials: { template_id: id } }));
            if (response.meta.requestStatus === "fulfilled") {
                setSnackbar({ open: true, message: response.payload.message, severity: "success" });
                dispatch(getChatBotThunk({ type: "getBot" }));
            } else {
                setSnackbar({ open: true, message: response.payload?.message || "Failed to delete ChatBot.", severity: "error" });
            }
        } catch (error) {
            console.error(error);
            setSnackbar({ open: true, message: "Something went wrong.", severity: "error" });
        }
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="md"
            keepMounted
            PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 860 } } }}
        >
            {/* Header */}
            <QrModalHeader
                icon={<AdsClickIcon />}
                title="Bot Click History"
                subtitle={chat_bot_name ? `Who clicked which option in "${chat_bot_name}"` : "Who clicked which bot option"}
                onClose={handleClose}
            />

            {/* Content */}
            <DialogContent sx={{ p: { xs: 1.5, sm: 2.5 } }}>
                {/* Tabs */}
                {/* <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
                    <Tabs value={tabValue} onChange={handleTabChange}>
                        <Tab label="View History" {...a11yProps(0)} />
                        <Tab label="Delete Bot" {...a11yProps(1)} />
                    </Tabs>
                </Box> */}

                {/* Tab Panels */}
                <Grid container spacing={2}>
                    {tabValue === 0 ? (
                        <Grid item size={{ xs: 12, md: 12 }}>
                            <DataTableWithCheckbox
                                enableRowSelection={false}
                                columns={columns}
                                data={tableData}
                                status={status1}
                                searchFirst
                                emptyMessage="No clicks recorded for this bot yet."
                            />
                        </Grid>
                    ) : (
                        <>
                            <Grid
                                item
                                size={{ xs: 12, md: 12 }}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <Typography>
                                    <span style={{ color: "red" }}>*</span> Are you sure you want to
                                    delete this "<b>{chat_bot_name}</b>" Bot?
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                size={{ xs: 12, md: 12 }}
                                sx={{ display: "flex", justifyContent: "center", mt: 1 }}
                            >
                                <CustomButton
                                    status={status}
                                    onClick={() => handleDeleteTemplate(rowData?.id)}
                                    label="Delete"
                                    loadingLabel="Deleting..."
                                    icon={<DeleteIcon />}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </DialogContent>

            {/* Snackbar */}
            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() =>
                    setSnackbar((prev) => ({
                        ...prev,
                        open: false,
                    }))
                }
            />
        </Dialog>
    );
}